// @vendors
const React = require('react');

// @components
const { OKLink } = require('commonsComponents/OKLink');
const { OKButton } = require('components/commons/OKButton/OKButton');

const buildLinkOrLabel = (label, link, className) => {
    if (link) {
        return (
            <OKLink
                extraClass={className}
                modifier="emphasize"
                to={link}
                target="_blank"
            >
                {label}
            </OKLink>
        )
    }

    return (
        <span className={className}>{label}</span>
    );
}

const buildLinkButton = (label, handleClick, className) => {
    return (
        <OKButton
            customLinkClassName={className}
            modifier="link-ghost"
            onClick={handleClick}
            autoHeight={__CONTACT_CENTER__}
        >
            <span className="ok-link ok-link--emphasize">{label}</span>
        </OKButton>
    );
}

module.exports = {
    buildLinkOrLabel,
    buildLinkButton,
}
